import request from '@/utils/request';
// 知识库目录列表
export function getDirectoryManagementList(params) {
  return request({
    url: '/orders/knowledge-catalogue/list',
    method: 'get',
    params: params
  });
}
// 获取编辑目录
export function getEditDirectoryManagement(params) {
  return request({
    url: '/orders/knowledge-catalogue/update',
    method: 'get',
    params: params
  });
}
// 新建目录
export function addDirectory(data) {
  return request({
    url: '/orders/knowledge-catalogue/create',
    method: 'post',
    data: data
  });
}
// 编辑目录
export function updateDirectory(data) {
  return request({
    url: '/orders/knowledge-catalogue/to-update',
    method: 'post',
    data: data
  });
}
// 删除目录
export function deleteDirectoryManagement(params) {
  return request({
    url: '/orders/knowledge-catalogue/delete',
    method: 'get',
    params: params
  });
}
// 知识库列表
export function getKnowledgeList(params) {
  return request({
    url: '/orders/knowledge/list',
    method: 'get',
    params: params
  });
}
// 获取编辑知识库
export function getEditKnowledge(params) {
  return request({
    url: '/orders/knowledge/update?',
    method: 'get',
    params: params
  });
}
// 新建知识库
export function addKnowledge(data) {
  return request({
    url: '/orders/knowledge/create',
    method: 'post',
    data: data
  });
}
// 编辑知识库
export function updateKnowledge(data) {
  return request({
    url: '/orders/knowledge/to-update',
    method: 'post',
    data: data
  });
}
// 删除知识库
export function deleteKnowledge(params) {
  return request({
    url: '/orders/knowledge/delete',
    method: 'get',
    params: params
  });
}
// 分类列表
export function getKnowOrganizeResponderList(params) {
  return request({
    url: '/orders/organize-work-item/index',
    method: 'get',
    params: params
  });
}
// 职能分工列表
export function getKnowCategoryResponderList(params) {
  return request({
    url: '/orders/organize-work-category/index',
    method: 'get',
    params: params
  });
}
// 职能分工 创建
export function createOrganizeWork(data) {
  return request({
    url: '/orders/organize-work-item/create',
    method: 'post',
    data: data
  });
}
// 职能分工 编辑
export function updateOrganizeWork(data) {
  return request({
    url: '/orders/organize-work-item/update',
    method: 'post',
    data: data
  });
}
// 职能分工列表
export function getOrganizeWorkDetail(params) {
  return request({
    url: '/orders/organize-work-item/read',
    method: 'get',
    params: params
  });
}
// 职能分工 删除
export function delOrganizeWorkItem(data) {
  return request({
    url: '/orders/organize-work-item/delete',
    method: 'post',
    data: data
  });
}
// 职能分工列表 - 日志
export function getOrganizeWorkLog(params) {
  return request({
    url: '/orders/organize-work-operate-log/index',
    method: 'get',
    params: params
  });
}
// 职能分工列表 - 日志
export function getOrganizeWorkEvaluate(params) {
  return request({
    url: '/orders/organize-work-item-evaluation/index',
    method: 'get',
    params: params
  });
}
// 职能分工 创建分类
export function createCategory(data) {
  return request({
    url: '/orders/organize-work-category/create',
    method: 'post',
    data: data
  });
}
// 职能分工 编辑分类
export function updateCategory(data) {
  return request({
    url: '/orders/organize-work-category/update',
    method: 'post',
    data: data
  });
}
// 职能分工 删除分类
export function delCategory(data) {
  return request({
    url: '/orders/organize-work-category/delete',
    method: 'post',
    data: data
  });
}
// 职能分工列表 - 日志
export function getCategoryDetails(params) {
  return request({
    url: '/orders/organize-work-category/read',
    method: 'get',
    params: params
  });
}
// 职能分工列表 - 反馈列表
export function getFeedbackList(params) {
  return request({
    url: '/orders/organize-work-feedback/index',
    method: 'get',
    params: params
  });
}
// 职能分工列表 - 反馈详情
export function getFeedbackRead(params) {
  return request({
    url: '/orders/organize-work-feedback/read',
    method: 'get',
    params: params
  });
}
// 职能分工 删除分类
export function saveFeedback(data) {
  return request({
    url: '/orders/organize-work-feedback/deal-feedback',
    method: 'post',
    data: data
  });
}
// 职能分工列表 - 导出
export function downloadWork(params) {
  return request({
    url: '/orders/organize-work-item/download',
    method: 'get',
    params: params
  });
}